var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"ux1-application"},[_c(_setup.SystemLayout),_c(_setup.NotificationsNode)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }